import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICE_MODELS } from '../../data/mock';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '../ui/card';
import { Button } from '../ui/button';
import { Check, Clock, Zap, Calendar } from 'lucide-react';

const iconMap = {
  standard: Clock,
  subscription: Calendar,
  priority: Zap,
};

const ServiceModelsSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111]">
            Choose your service model
          </h2>
          <p className="mt-4 text-lg text-[#475569]">
            Flexible options designed for different installer needs
          </p>
        </div>

        {/* Service Cards */}
        <div className="mt-10 grid md:grid-cols-3 gap-8">
          {SERVICE_MODELS.map((model) => {
            const IconComponent = iconMap[model.id];
            return (
              <Card 
                key={model.id} 
                className={`card-hover relative ${
                  model.highlighted 
                    ? 'service-card-highlighted shadow-lg' 
                    : 'border-[#E2E8F0]'
                }`}
              >
                <CardHeader className="pt-8">
                  <div className="w-12 h-12 rounded-xl bg-[#F0FDFA] flex items-center justify-center mb-4">
                    <IconComponent className="w-6 h-6 text-[#0D9488]" />
                  </div>
                  <CardTitle className="text-xl font-bold text-[#111111]">
                    {model.name}
                  </CardTitle>
                  <CardDescription className="text-[#0D9488] font-medium">
                    {model.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {model.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <Check className="w-5 h-5 text-[#0D9488] flex-shrink-0 mt-0.5" />
                        <span className="text-[#475569]">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
                <CardFooter className="pt-4">
                  <Link to="/pricing" className="w-full">
                    <Button 
                      variant={model.highlighted ? "default" : "outline"}
                      className={`w-full ${
                        model.highlighted 
                          ? 'bg-[#0D9488] hover:bg-[#0F766E] text-white' 
                          : 'border-[#E2E8F0] text-[#111111] hover:border-[#0D9488] hover:bg-[#F0FDFA]'
                      }`}
                    >
                      Learn More
                    </Button>
                  </Link>
                </CardFooter>
              </Card>
            );
          })}
        </div>

        {/* CTA Row */}
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
          <Link to="/pricing">
            <Button variant="outline" size="lg" className="border-[#E2E8F0] text-[#111111] hover:border-[#0D9488] px-8">
              Request Pricing
            </Button>
          </Link>
          <Link to="/book/waste">
            <Button size="lg" className="bg-[#0D9488] hover:bg-[#0F766E] text-white px-8">
              Book Collection
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServiceModelsSection;
